import request from 'utils/request'

/**
 * 获取限额延期申请待审批列表special
 * @param {*} data
 */
export const getLimitList = data => request().post('limit/task/page', data)

/**
 * 获取限额延期申请待审批列表special
 * @param {*} data
 */
export const getSpecialList = data => request().post('limit/special/page', data)


/**
 * 审批
 * @param {*} data
 */
export const doApprove = data => request(false).post('limit/approve', data)

/**
 * 获取批量申请待审批列表
 * @param {*} data
 */
export const getBatchAuditList = data =>
  request().post('limit/batch/task/page', data)

/**
 * 获取批量申请审批详情
 * @param {*} id
 */
export const getBatchApprovalDetail = id =>
  request().get(`limit/batch/task/detail/${id}`)

/**
 * 提交批量申请审批
 * @param {*} data
 */
export const doBatchApprove = data => request().post('bp/batch/approve', data)

export const downloadLimitTable = data =>
  request().post('limit/limit/export', data, { responseType: 'arraybuffer' })

  export const downloadSpcialTable = data =>
  request().post('limit/special/export', data, { responseType: 'arraybuffer' })

/**
 * 获取限额延期批量申请审批详情
 * @param {*} id
 */
export const getBatchLimitDetail = id =>
request().get(`limit/batch/task/detail/${id}`)

/**
 * 限额延期提交批量申请审批
 * @param {*} data
 */
export const doLimitBatchApprove = data => request().post('limit/batch/approve', data)
